import { Injectable } from '@angular/core';
import { ProdutoList } from '../models/produto-list.model';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CadastroProdutoService extends BaseService<ProdutoList> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/produtos';
  }

}
